import React, {useEffect, useState, useContext} from 'react';
import styled from "styled-components";
import {useWindowSize} from "@helpers/windows.size";
import {getWidgets} from "@models/widget";
import LandingProperties from "@organisms/property/landing/properties";
import IsOwnerBanner from "@molecules/banners/is.owner";
import IsRealtorBanner from "@molecules/banners/is.realtor";
import Stats from '@molecules/stats/stats';
import {UserContext} from "@providers/user";
import {isEmpty, str_replace} from "@helpers/helpers";
import {getCityById} from "../../../models/district";
import {getLandingCityHasVideoProperties, getLandingCityRentProperties, getLandingCitySaleProperties} from "../../../components/organisms/property/helpers/search_helper";
import MostActiveRealtor from "../../../components/molecules/realtor/most_active_realtors";
import BrandingText from "../../../components/molecules/widgets/branding_text";
import CitiesLandingMainSection from "../../../components/organisms/property/landing/cities/main_section";
import {getSearchFaq} from "@organisms/property/helpers/search_helper";
import FaqsWidget from "@molecules/widgets/faqs";
import MostActiveAgencies from "../../../components/organisms/property/components/most_active_agencies";
import LandingSeeMorePropertyBtn from "@organisms/property/components/landing_see_more_property_btn";
import {inArray} from "../../../components/helpers/arrays";

const statItems = [
    {num: '1000000', label: ' ملک‌ آگهی‌شده در ۲نبش'},
    {num: '11000', label: 'مشاور فعال ۲نبش در سرتاسر ایران'},
    {num: '2000000', label: 'بازدید ماهانه از ۲نبش'},
];


const CitiesHomeLanding = ({city_id, citySalePropertiesWidget, cityRentPropertiesWidget, cityHasVideoPropertiesWidget, mostActiveRealtorsLists, faqsList, setContactInfo, ssrBrandingText}) => {
    const windowSize = useWindowSize();
    const userContext = useContext(UserContext);

    const authCheck = userContext.check;
    const [defaultCity, setDefaultCity] = useState(null);

    const [cityContent, setCityContent] = useState([]);
    const [salePropertiesState, setSaleProperties] = useState((citySalePropertiesWidget && citySalePropertiesWidget.length) ? citySalePropertiesWidget : []);
    const [rentPropertiesState, setRentProperties] = useState((cityRentPropertiesWidget && cityRentPropertiesWidget.length) ? cityRentPropertiesWidget : []);
    const [hasVideoPropertiesState, setHasVideoProperties] = useState((cityHasVideoPropertiesWidget && cityHasVideoPropertiesWidget.length) ? cityHasVideoPropertiesWidget : []);
    const [faqs, setFaqs] = useState(faqsList ?? []);

    useEffect(() => {
        getCityById(city_id).then(city => {
            setDefaultCity(city)
        });
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = document.documentElement.scrollTop;

            const navbar = document.querySelector('.properties-search-navbar');

            if (windowSize < 992) {
                if (scrollTop > 100) {
                    if (!isEmpty(navbar) && navbar.classList.contains('cities-landing-navbar')) {
                        navbar.classList.remove('cities-landing-navbar');
                    }
                } else {
                    if (!isEmpty(navbar) && !navbar.classList.contains('cities-landing-navbar')) {
                        navbar.classList.add('cities-landing-navbar');
                    }
                }
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll)
    });

    useEffect(() => {
        if (!isEmpty(defaultCity)) {

            if (!salePropertiesState.length) {
                getLandingCitySaleProperties(defaultCity.id).then(result => {
                    setSaleProperties(result);

                    if (isEmpty(result) || result.length < 4) {
                        const saleSection = document.querySelector('.sale-properties-section');

                        if (!isEmpty(saleSection)) {
                            saleSection.remove();
                        }
                    }
                })
            }

            if (!rentPropertiesState.length) {
                getLandingCityRentProperties(defaultCity.id).then(result => {
                    setRentProperties(result)

                    if (isEmpty(result) || result.length < 4) {
                        const rentSection = document.querySelector('.rent-properties-section');

                        if (!isEmpty(rentSection)) {
                            rentSection.remove();
                        }
                    }
                })
            }

            if (!hasVideoPropertiesState.length) {
                getLandingCityHasVideoProperties(defaultCity.id).then(result => {
                    setHasVideoProperties(result)

                    if (isEmpty(result) || result.length < 4) {
                        const hasVideoSection = document.querySelector('.has-video-properties-section');

                        if (!isEmpty(hasVideoSection)) {
                            hasVideoSection.remove();
                        }
                    }
                })
            }

            if (!cityContent.length) {
                const params = {
                    type: 'content',
                    page: 'properties',
                    section: 'properties',
                    city_id: defaultCity.id,
                };

                getWidgets(params).then(result => {
                    setCityContent((!isEmpty(result.widgets) && !isEmpty(result.widgets[0])) ? result.widgets[0] : '');
                })
            }

            if (!faqs.length) {
                const params = {
                    city_id: defaultCity.id,
                };

                getSearchFaq(params, 'home').then(widgets => {
                    setFaqs(widgets)
                });
            }
        }
    }, [defaultCity]);


    // add first ssr properties list
    const saleProperties = (salePropertiesState.length ? salePropertiesState : ((citySalePropertiesWidget && citySalePropertiesWidget.length) ? citySalePropertiesWidget : []));
    const rentProperties = (rentPropertiesState.length ? rentPropertiesState : ((cityRentPropertiesWidget && cityRentPropertiesWidget.length) ? cityRentPropertiesWidget : []));
    const hasVideoProperties = (hasVideoPropertiesState.length ? hasVideoPropertiesState : ((cityHasVideoPropertiesWidget && cityHasVideoPropertiesWidget.length) ? cityHasVideoPropertiesWidget : []));

    return (
        <Container className="pb-56">
            <CitiesLandingMainSection
                windowSize={windowSize}
                defaultCityId={!isEmpty(defaultCity) ? defaultCity.id : null}/>

            <Sections className="container">
                <h1 className="mb-16">املاک {!isEmpty(defaultCity) ? defaultCity.name : ''}</h1>
                {
                    (!authCheck) ?
                        <IsOwnerBanner/>
                        : ''
                }
            </Sections>

            <Sections className={'sale-properties-section ' + (authCheck ? 'mt-0' : '')}>
                <div className="container d-flex align-items-center justify-content-between mb-16">
                    <h2 className="">خرید املاک {!isEmpty(defaultCity) ? defaultCity.name : ''}</h2>

                    <div className="cities-show-more-wrapper d-none d-lg-block">
                        <LandingSeeMorePropertyBtn hrefAs={'/املاک-' + str_replace(' ', '-', !isEmpty(defaultCity) ? defaultCity.name : '') + '/خرید-فروش-آپارتمان'}/>
                    </div>
                </div>

                <div className="container sm-fluid">
                    <LandingProperties properties={saleProperties}/>
                </div>

                <div className="container mt-24 mt-lg-32 cities-show-more-wrapper d-lg-none">
                    <LandingSeeMorePropertyBtn hrefAs={'/املاک-' + str_replace(' ', '-', !isEmpty(defaultCity) ? defaultCity.name : '') + '/خرید-فروش-آپارتمان'}/>
                </div>
            </Sections>

            <Sections className="js-most-active-agency-section">

                <div className="container sm-fluid">
                    {
                        !isEmpty(defaultCity) ?
                            <MostActiveAgencies
                                city_id={defaultCity.id}
                                setContactInfo={setContactInfo}
                                className=""
                                sectionTitle={`املاک منتخب ${defaultCity.name}`}
                                count={(inArray(defaultCity.id, [3198, 17879]) ? 28 : 12)}
                            />
                            : ''
                    }
                </div>
            </Sections>

            {
                (!authCheck) ?
                    <Sections className="container is-realtor-banner-wrapper">
                        <IsRealtorBanner/>
                    </Sections> :
                    ''
            }

            <Sections className={'rent-properties-section '}>
                <div className="container d-flex align-items-center justify-content-between mb-16">
                    <h2 className="">رهن و اجاره املاک {!isEmpty(defaultCity) ? defaultCity.name : ''}</h2>

                    <div className="cities-show-more-wrapper d-none d-lg-block">
                        <LandingSeeMorePropertyBtn hrefAs={'/املاک-' + str_replace(' ', '-', !isEmpty(defaultCity) ? defaultCity.name : '') + '/رهن-اجاره-آپارتمان'}/>
                    </div>
                </div>

                <div className="container sm-fluid">
                    <LandingProperties properties={rentProperties}/>
                </div>

                <div className="container mt-24 mt-lg-32 cities-show-more-wrapper d-lg-none">
                    <LandingSeeMorePropertyBtn hrefAs={'/املاک-' + str_replace(' ', '-', !isEmpty(defaultCity) ? defaultCity.name : '') + '/رهن-اجاره-آپارتمان'}/>
                </div>
            </Sections>

            <Sections className="container">
                <StatsWrapper statItems={statItems} className="mt-0" carouselClassName="py-8 px-0"/>
            </Sections>


            <Sections className=" js-active-realtors-last-week">
                <div className="container">
                    <p className="mb-16"><strong className="h2">مشاورین فعال 7 روز اخیر {!isEmpty(defaultCity) ? defaultCity.name : ''}</strong></p>
                </div>

                <div className="container sm-fluid">
                    {
                        !isEmpty(defaultCity) ?
                            <MostActiveRealtor
                                city_id={defaultCity.id}
                                last_week={true}
                                mostActiveRealtorsLists={mostActiveRealtorsLists}
                                sectionClassName="js-active-realtors-last-week"/>
                            : ''
                    }
                </div>
            </Sections>


            <Sections className={'has-video-properties-section '}>
                <div className="container d-flex align-items-center justify-content-between mb-16">
                    <h2 className="">ملک‌های ویدئودار {!isEmpty(defaultCity) ? defaultCity.name : ''}</h2>

                    <div className="cities-show-more-wrapper d-none d-lg-block">
                        <LandingSeeMorePropertyBtn hrefAs={'/املاک-' + str_replace(' ', '-', !isEmpty(defaultCity) ? defaultCity.name : '') + '?has_video=1'}/>
                    </div>
                </div>

                <div className="container sm-fluid">
                    <LandingProperties properties={hasVideoProperties}/>
                </div>

                <div className="container mt-24 mt-lg-32 cities-show-more-wrapper d-lg-none">
                    <LandingSeeMorePropertyBtn hrefAs={'/املاک-' + str_replace(' ', '-', !isEmpty(defaultCity) ? defaultCity.name : '') + '?has_video=1'}/>
                </div>
            </Sections>


            {
                (faqs.length) ?
                    <Sections className="container ">
                        <FaqsWidget faqs={faqs}/>
                    </Sections>
                    : ''
            }

            <Sections className={"container "}>
                <BrandingText skeleton={false} content={ssrBrandingText} searchParams={{city_id: city_id}}/>
            </Sections>
        </Container>
    );
};

export default React.memo(CitiesHomeLanding);

// styles

const StatsWrapper = styled(Stats)`
  .stats-carousel-item {
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
    padding: 32px 24px;
    border-radius: 8px;
  }
`;

const Container = styled.div`

  .most-visited-properties-wrapper {
    a {
      display: block;
      width: 100%;
      margin-top: 16px;
    }
  }

  @media (max-width: ${props => props.theme.screenSmMax}) {
    margin-bottom: 64px;
  }
`;

const Sections = styled.section`
  margin-top: 80px;

  .content {
    h2, h3 {
      margin: 32px 0 16px;
    }
  }

  @media (max-width: ${props => props.theme.screenSmMax}) {
    margin-top: 64px;
  }
`;